import * as THREE from 'three';

export const createMedal = ( textureSchool, textureMaterial, circleColor ) => {

      /*Хуйня */

    const parent_Mesh =  new THREE.Mesh(new THREE.BoxGeometry(0, 0, 0), new THREE.MeshBasicMaterial({
        color: "#FFFFFF00",
        wireframe: true
    }));

    const geometry = new THREE.CylinderGeometry(
    3, 3, 0.2, 55);        

    const material = new THREE.ShaderMaterial (
    {
        uniforms: {
        u_texture: {value: textureSchool},
        u_gold: {value: textureMaterial},
        Time: {value: 0},
        goldy : {value: 0}
        },
        fragmentShader: document.getElementById("spaceTestFragmentShader2").innerHTML, 
        vertexShader: document.getElementById("spaceTestVertexShader").innerHTML
    }
    )

    material.transparent = true;

    const mesh = new THREE.Mesh(geometry, material);

    mesh.rotation.y = 1.6;
    mesh.rotation.x = 1.6;   


    const geometry2 = new THREE.RingGeometry(
    3, 3.5, 55);

        

    const material2 = new THREE.MeshPhongMaterial (
        {
        map: textureMaterial,
        shininess: 2,
        }
    )

    const mesh2 = new THREE.Mesh(geometry2, material2);


    parent_Mesh.add(mesh);
    parent_Mesh.add(mesh2);

    // круг-подложка позади медали (виден через прозрачные участки шейдера), вращается вместе с ней.
    // Добавляем ПОСЛЕДНИМ — rotate() обращается к children[0].material.uniforms.Time (цилиндр с шейдером).
    if (circleColor) {
      const circleGeometry = new THREE.CircleGeometry(3.5, 55);
      const circleMaterial = new THREE.MeshBasicMaterial({ color: circleColor, side: THREE.DoubleSide });
      const circle = new THREE.Mesh(circleGeometry, circleMaterial);
      circle.position.z = -0.25;
      parent_Mesh.add(circle);
    }

    return parent_Mesh;

}

export const createBoxMedal = ( textureSchool, textureMaterial, circleColor ) => {

    /*Хуйня */

  const parent_Mesh =  new THREE.Mesh(new THREE.BoxGeometry(0, 0, 0), new THREE.MeshBasicMaterial({
      color: "#FFFFFF00",
      wireframe: true
  }));

  const geometry = new THREE.CylinderGeometry(
    2.5, 2.5, 0.2, 55);  

  const material = new THREE.ShaderMaterial (
  {
      uniforms: {
      u_texture: {value: textureSchool},
      u_gold: {value: textureMaterial},
      Time: {value: 0},
      goldy : {value: 0}
      },
      fragmentShader: document.getElementById("spaceTestFragmentShader2").innerHTML, 
      vertexShader: document.getElementById("spaceTestVertexShader").innerHTML
  }
  )

  material.transparent = true;

  const mesh = new THREE.Mesh(geometry, material);

  mesh.rotation.y = 1.6;
  mesh.rotation.x = 1.6;   
  mesh.position.z = 0.1; 


  const geometry2 = new THREE.PlaneGeometry(
  6, 6, 30, 30);

      

  const material2 = new THREE.MeshPhongMaterial (
      {
      map: textureMaterial,
      shininess: 2,
      }
  )

  const mesh2 = new THREE.Mesh(geometry2, material2);
  material2.transparent = true;

  parent_Mesh.add(mesh);
  parent_Mesh.add(mesh2);

  // круг-подложка позади медали (виден через прозрачные участки шейдера), вращается вместе с ней.
  // Добавляем ПОСЛЕДНИМ — rotate() обращается к children[0].material.uniforms.Time (цилиндр с шейдером).
  if (circleColor) {
    const circleGeometry = new THREE.CircleGeometry(3, 55);
    const circleMaterial = new THREE.MeshBasicMaterial({ color: circleColor, side: THREE.DoubleSide });
    const circle = new THREE.Mesh(circleGeometry, circleMaterial);
    circle.position.z = -0.2;
    parent_Mesh.add(circle);
  }

  return parent_Mesh;

}